const rootReducer = {
  config: {},
};

export default rootReducer;
